import instance from "../axiosConfig";
import { CreatePage, Page } from "./models";

export class PageService {
    private regionCode: string;

    constructor(regionCode: string) {
        this.regionCode = regionCode;
    }

    getPages = async (): Promise<Page[]> => {
        const response = await instance.get<Page[]>(`api/admin/${this.regionCode}/pages`);

        return response.data;
    };

    getPage = async (pageId: string): Promise<Page> => {
        const response = await instance.get<Page>(`api/admin/${this.regionCode}/pages/${pageId}`);

        return response.data;
    };

    createPage = async (body: CreatePage): Promise<Page> => {
        const response = await instance.post<Page>(`api/admin/${this.regionCode}/pages`, body, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    };

    updatePage = async (pageId: string, body: CreatePage): Promise<Page> => {
        const response = await instance.put<Page>(`api/admin/${this.regionCode}/pages/${pageId}`, body, {
            headers: {
                "Content-Type": "application/json",
            },
        });

        return response.data;
    };

    deletePage = async (pageId: string): Promise<boolean> => {
        try {
            const response = await instance.delete<Page>(`api/admin/${this.regionCode}/pages/${pageId}`);

            return response.status >= 200 && response.status < 300;
        } catch {
            return false;
        }
    };
}
